/**
 * Permet de faire afficher un "Bootstrap Docs Sidebar" dynamiquement, selon les ".section" et les ".sous-section"
 * Permet également le smoothscroll
 *
 * Code du Docs Sidebar : Kyle Mitofsky (http://www.codingeverything.com/2014/02/BootstrapDocsSideBar.html)
 *
 * @author     G Communication Marketing
 * @copyright  2016 - G Communication Marketing (Agence G)
 */

var sidebar = jQuery('.sidebar-doc-content');
var code = '';
code = code + '<ul class="nav nav-stacked vertical menu" id="sidebar">';

var sections = jQuery('.bootstrap .section');

sections.each(function(index) {
	code = code + '<li>';

		var titre_section = jQuery(this).find('h2').get(0).innerText;
		var id = jQuery(this).attr('id');
		code = code + '<a href="#' + id + '" class="left-border smoothscroll">' + titre_section + '</a>';

		code = code + '<ul class="nav nav-stacked" >';

			var sous_sections = jQuery('#' + id + ' .sous-section');
			sous_sections.each(function(index) {
				code = code + '<li>';

					var titre_sous_section = jQuery(this).find('h3').get(0).innerText;
					var id = jQuery(this).attr('id');
					code = code + '<a href="#' + id + '" class="smoothscroll">' + titre_sous_section + '</a>';

				code = code + '</li>';
			});

		code = code + '</ul>';

	code = code + '</li>';
});

code = code + '</ul>';

sidebar.prepend(code);

// Scrollspy
jQuery('body').scrollspy({
    target: '.bootstrap',
    offset: 100
});

jQuery(".sidebar-doc-content").affix({
    offset: {
        top: 300,
				bottom: 300,
    }
});

// var spy = new ScrollSpy('#js-scrollspy', {
//   nav: '.js-scrollspy-nav > li > a',
//   className: 'is-inview'
// });

jQuery('.smoothscroll').on('click', function() {
	var page = jQuery(this).attr('href');
	var speed = 750;
	jQuery('html, body').animate( { scrollTop: jQuery(page).offset().top }, speed );
});



//////////////////
// WEBPACK FOOTER
// ./src/js/sidebar-doc.js
// module id = 5
// module chunks = 0